import { useTranslation } from 'react-i18next'

export type StatusFilter = '' | 'processing' | 'waiting' | 'failed' | 'done' | 'upstream_missing'

const STATUS_FILTER_KEYS: StatusFilter[] = ['', 'processing', 'waiting', 'failed', 'upstream_missing', 'done']

/** Phase 2B-2 §7.1 — the one canonical list of status tab labels, extracted
 * out of `Home.tsx` verbatim. Both the standalone asset list and the SaaS
 * Workspace Images page render this same array so status names/order can
 * never drift or get "reinvented" between the two (spec: "不要自己创造新的
 * 状态名称"). */
export default function StatusFilterTabs({
  value,
  onChange,
}: {
  value: StatusFilter
  onChange: (v: StatusFilter) => void
}) {
  const { t } = useTranslation('autoProcess')

  return (
    <div className="status-tab-row">
      {STATUS_FILTER_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          className={`status-tab${value === key ? ' active' : ''}`}
          onClick={() => onChange(key)}
          data-testid={`status-tab-${key || 'all'}`}
        >
          {t(`statusFilter.${key || 'all'}`)}
        </button>
      ))}
    </div>
  )
}
